import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgApplication = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 25 25"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path d="M.678.435h24v24h-24z" />
      <path
        d="M2.603 6.117 12.244.551a.867.867 0 0 1 .867 0l9.642 5.566a.867.867 0 0 1 .433.751v11.133c0 .31-.165.596-.433.75L13.11 24.32a.867.867 0 0 1-.867 0l-9.641-5.567a.867.867 0 0 1-.434-.75V6.867c0-.31.165-.596.434-.75Zm1.41 1.19a.217.217 0 0 0-.108.188v9.88c0 .077.041.148.108.187l8.556 4.94c.067.039.15.039.217 0l8.556-4.94a.217.217 0 0 0 .108-.188v-9.88a.217.217 0 0 0-.108-.187l-8.556-4.94a.217.217 0 0 0-.217 0l-8.556 4.94Zm8.656 4.238 6.673-3.853a.867.867 0 0 1 .867 1.5l-6.656 3.844v7.618a.867.867 0 0 1-1.733 0v-7.598l-6.668-3.85a.867.867 0 0 1 .867-1.5l6.65 3.839Z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </g>
  </svg>
)

const ForwardRef = forwardRef(SvgApplication)
const Memo = memo(ForwardRef)
export default Memo
